
import a_wing from '../assets/images/RamjiResidency/FloorPlan/a_wing.jpg'
import b_wing from '../assets/images/RamjiResidency/FloorPlan/b_wing.jpg'
import c_wing from '../assets/images/RamjiResidency/FloorPlan/c_wing.jpg'
import d_wing from '../assets/images/RamjiResidency/FloorPlan/d_wing.jpg'
import e_wing from '../assets/images/RamjiResidency/FloorPlan/e_wing.jpg'
import f_wing from '../assets/images/RamjiResidency/FloorPlan/f_wing.jpg'
import g_wing from '../assets/images/RamjiResidency/FloorPlan/g_wing.jpg'

import backIcon from "../assets/images/back_icon.png";

import '../assets/css/floorplan.css';
import { useState } from 'react';
import { Modal } from 'react-bootstrap'

const FloorPlanRamjiResidency = () => {
    const [isZoomed, setIsZoomed] = useState(false);

    const [activeFilterIndex, setActiveFilterIndex] = useState(0);
    const [imageSrc, setImageSrc] = useState(a_wing);
    const [wing, setWing] = useState("A");


    const [showPlan, setShowPlan] = useState(false);
    const [isTypicalPlan, setIsTypicalPlan] = useState(false)

    const [openFlat, setOpenFlat] = useState("");
    const [showIframe, setShowIframe] = useState(false);

    const changeFloorPlan = (floorPlan, index) => {
        setActiveFilterIndex(index);
        setImageSrc(floorPlan);
    }

    return (
        <div className="courtyard elysium_tower floorplan_container RamjiResidency">
            <div className="w-100 d-flex justify-content-sm-between h-100">
                <div className="left_side_container grey-bg">
                    <img alt="floor_plan_image" src={imageSrc} style={{ maxWidth: "100%" }} className={`zoomable-image ${isZoomed ? "zoomed" : ""}`} onClick={() => setIsZoomed(!isZoomed)} />
                    <div className='view-web-vr center d-flex'>
                        {
                            wing === "A" && <>
                                <div className=''><button className='view-web-vr-btn' onClick={() => { setShowPlan(true); setOpenFlat('https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Ramji_Recidency/ramji_recidency_3BHK/index.html') }}>View 01</button> </div>
                                <div className=''><button className='view-web-vr-btn' onClick={() => { setShowPlan(true); setOpenFlat('https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Ramji_Recidency/ramji_recidency_3BHK/index.html') }}>View 02</button> </div>
                                <div className=''><button className='view-web-vr-btn' onClick={() => { setShowPlan(true); setOpenFlat('https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Ramji_Recidency/ramji_recidency_3BHK/index.html') }}>View 03</button> </div>
                                <div className=''><button className='view-web-vr-btn' onClick={() => { setShowPlan(true); setOpenFlat('https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Ramji_Recidency/ramji_recidency_3BHK/index.html') }}>View 04</button> </div>
                            </>
                        }
                        {
                            (wing === "B" || wing === "C" || wing === "D" || wing === "E" || wing === "F" || wing === "G") && <>
                                <div className=''><button className='view-web-vr-btn' onClick={() => { setShowPlan(true); setOpenFlat('https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Ramji_Recidency/ramji_recidency_2bhk-699/index.html') }}>View 01</button> </div>
                                <div className=''><button className='view-web-vr-btn' onClick={() => { setShowPlan(true); setOpenFlat('https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Ramji_Recidency/ramji_recidency_2bhk-699/index.html') }}>View 02</button> </div>
                                <div className=''><button className='view-web-vr-btn' onClick={() => { setShowPlan(true); setOpenFlat('https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Ramji_Recidency/ramji_recidency_2bhk-737/index.html') }}>View 03</button> </div>
                                <div className=''><button className='view-web-vr-btn' onClick={() => { setShowPlan(true); setOpenFlat('https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Ramji_Recidency/ramji_recidency_2bhk-737/index.html') }}>View 04</button> </div>
                            </>
                        }
                    </div>
                </div>
                <div className="right_side_container">
                    <div className='floor_plan_button-conainer'>
                        <button className="floor_plan_lable">Floor Plans</button>
                        <button onClick={() => { changeFloorPlan(a_wing, 0); setWing('A'); }} className={`${activeFilterIndex === 0 ? 'active' : ''} `}>A Wing</button>
                        <button onClick={() => { changeFloorPlan(b_wing, 1); setWing("B") }} className={`${activeFilterIndex === 1 ? 'active' : ''} `}>B Wing</button>
                        <button onClick={() => { changeFloorPlan(c_wing, 4); setWing('C') }} className={`${activeFilterIndex === 4 ? 'active' : ''} `}>C Wing</button>
                        <button onClick={() => { changeFloorPlan(d_wing, 2); setWing("D"); }} className={`${activeFilterIndex === 2 ? 'active' : ''} `}>D Wing</button>
                        <button onClick={() => { changeFloorPlan(e_wing, 6); setWing("E") }} className={`${activeFilterIndex === 6 ? 'active' : ''} `}>E Wing</button>
                        <button onClick={() => { changeFloorPlan(f_wing, 3); setWing("F") }} className={`${activeFilterIndex === 3 ? 'active' : ''} `}>F wing</button>
                        <button onClick={() => { changeFloorPlan(g_wing, 7); setWing("G") }} className={`${activeFilterIndex === 7 ? 'active' : ''} `}>G wing</button>
                    </div>

                </div>
            </div>

            <Modal
                centered
                show={showPlan}
                onHide={() => setShowPlan(false)}
                aria-labelledby="example-custom-modal-styling-title"
                className="inventory_floor_plan_dialog"
            >
                <Modal.Body>
                    <button className="back_btn" onClick={() => { if (showIframe) { setShowIframe(false); } else { setShowPlan(false) } }}>
                        <img src={backIcon} alt="back icon" className="backIcon" />
                    </button>
                    <iframe src={openFlat} height="100%" width="100%" className="flats_iframe flats_iframe_elysium" />
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default FloorPlanRamjiResidency;